var _circle, _circle2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 18.257,
    r: 18.257,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.257,
    cy: 18.257,
    r: 18.257,
    fill: "url(#paint0_linear_1688_12797)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1688_12797)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7035 15.0215C26.6637 14.1182 26.5176 13.4972 26.3084 12.9591C26.0925 12.3879 25.7604 11.8766 25.3253 11.4515C24.9002 11.0197 24.3855 10.6843 23.8209 10.4718C23.2797 10.2625 22.6619 10.1165 21.7586 10.0766C20.8486 10.0334 20.5597 10.0234 18.2517 10.0234C15.9436 10.0234 15.6547 10.0334 14.748 10.0733C13.8448 10.1131 13.2238 10.2593 12.6858 10.4684C12.1145 10.6843 11.6031 11.0164 11.178 11.4515C10.7463 11.8766 10.4109 12.3913 10.1983 12.9559C9.98908 13.4972 9.84301 14.1148 9.80319 15.0181C9.75999 15.9281 9.75 16.217 9.75 18.5251C9.75 20.8332 9.75999 21.1221 9.79981 22.0287C9.83964 22.932 9.98584 23.553 10.1951 24.0911C10.4109 24.6623 10.7463 25.1736 11.178 25.5987C11.6031 26.0305 12.1179 26.3659 12.6824 26.5784C13.2238 26.7877 13.8414 26.9337 14.7448 26.9736C15.6513 27.0135 15.9404 27.0234 18.2484 27.0234C20.5565 27.0234 20.8454 27.0135 21.752 26.9736C22.6553 26.9337 23.2763 26.7877 23.8143 26.5784C24.9568 26.1367 25.86 25.2334 26.3018 24.0911C26.5109 23.5497 26.6571 22.932 26.6969 22.0287C26.7367 21.1221 26.7467 20.8332 26.7467 18.5251C26.7467 16.217 26.7433 15.9281 26.7035 15.0215ZM25.1726 21.9623C25.136 22.7925 24.9966 23.2409 24.8804 23.5397C24.5947 24.2803 24.0069 24.8681 23.2663 25.1538C22.9674 25.27 22.5159 25.4095 21.6889 25.4459C20.7922 25.4859 20.5233 25.4957 18.255 25.4957C15.9868 25.4957 15.7145 25.4859 14.8211 25.4459C13.9908 25.4095 13.5425 25.27 13.2436 25.1538C12.8751 25.0176 12.5396 24.8017 12.2673 24.5194C11.985 24.2438 11.7692 23.9117 11.633 23.5431C11.5167 23.2442 11.3773 22.7925 11.3408 21.9657C11.3009 21.069 11.291 20.8 11.291 18.5317C11.291 16.2635 11.3009 15.9912 11.3408 15.0979C11.3773 14.2677 11.5167 13.8193 11.633 13.5204C11.7692 13.1518 11.985 12.8164 12.2707 12.544C12.5462 12.2617 12.8783 12.0459 13.247 11.9098C13.5459 11.7935 13.9976 11.6541 14.8245 11.6175C15.7211 11.5777 15.9902 11.5677 18.2583 11.5677C20.5299 11.5677 20.7988 11.5777 21.6922 11.6175C22.5225 11.6541 22.9708 11.7935 23.2697 11.9098C23.6382 12.0459 23.9737 12.2617 24.246 12.544C24.5283 12.8197 24.7441 13.1518 24.8804 13.5204C24.9966 13.8193 25.136 14.2709 25.1726 15.0979C25.2125 15.9946 25.2224 16.2635 25.2224 18.5317C25.2224 20.8 25.2125 21.0656 25.1726 21.9623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2518 14.1582C15.8409 14.1582 13.8848 16.1142 13.8848 18.5253C13.8848 20.9363 15.8409 22.8923 18.2518 22.8923C20.6629 22.8923 22.6189 20.9363 22.6189 18.5253C22.6189 16.1142 20.6629 14.1582 18.2518 14.1582ZM18.2518 21.3581C16.6877 21.3581 15.419 20.0895 15.419 18.5253C15.419 16.961 16.6877 15.6925 18.2518 15.6925C19.8161 15.6925 21.0846 16.961 21.0846 18.5253C21.0846 20.0895 19.8161 21.3581 18.2518 21.3581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8126 13.9853C23.8126 14.5483 23.3561 15.0048 22.7929 15.0048C22.2299 15.0048 21.7734 14.5483 21.7734 13.9853C21.7734 13.4222 22.2299 12.9658 22.7929 12.9658C23.3561 12.9658 23.8126 13.4222 23.8126 13.9853Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1688_12797",
    x1: 2.45162,
    y1: 34.1352,
    x2: 36.2844,
    y2: 4.84756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1688_12797"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white",
    transform: "translate(9.7207 10.0234)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.e4ca923cba620c2c2767a39d70513548.svg";
export { ForwardRef as ReactComponent };